import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-white text-neutral-900 text-center px-6">
      <h1 className="absolute bottom-0 font-display text-[10rem] md:text-[16rem] font-medium tracking-tightest text-neutral-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <p className="overline text-neutral-400">Página no encontrada</p>
        <h1 className="font-display text-2xl md:text-4xl font-medium tracking-tightest mt-4">
          Esta página no existe
        </h1>
        <p className="mt-3 text-neutral-500">{location.pathname}</p>
        <Link
          to="/"
          className="whitespace-nowrap inline-flex items-center justify-center mt-8 px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] bg-neutral-900 text-white hover:bg-neutral-700 transition-colors"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}